export const lulin = [{id: 1, name: "Гуми"}, {id: 4, name: "Реглаж"}, {id: 7, name: "ГТП"}];

export const mladost = [{id: 1, name: "Гуми"}, {id: 4, name: "Реглаж"}];

export const evropa = [{id: 4, name: "Реглаж"}, {id: 7, name: "ГТП"}];

export const hitMladost = [{id: 4, name: "Реглаж"}, {id: 7, name: "ГТП"}];

export const getServiceById = (id) => {
    switch (id) {
        case 1:
            return {
                id: 1,
                name: "Люлин - паркинг на ХИТ и Практикер"
            }
        case 2:
            return {
                id: 2,
                name: "Младост"
            }
        case 5:
            return {
                id: 5,
                name: "Европа - срещу Mr.Bricolage"
            }
        case 6:
            return {
                id: 6,
                name: "Младост - паркинг НIT Max"
            }
        default:
            return {
                id: 0,
                name: ""
            }
    }
}